import { useFetchViewsByCategory } from '../../standardViews/hooks/useFetchViewsByCategory';
import { useDebouncedValue } from '../../cloneView/hooks/useDebouncedValue';
import { useMemo } from 'react';
const QUERY_OBJECT_DEBOUNCE_TIME_MS = 500;
export const useDebouncedFetchViewsByCategory = ({
  objectTypeId,
  query,
  namespace,
  category,
  fetchPolicy,
  count = 6
}) => {
  const viewsSearchQuery = useMemo(() => ({
    objectTypeId,
    query,
    namespace,
    category,
    count,
    fetchPolicy
  }), [objectTypeId, namespace, category, query, count, fetchPolicy]);
  const debouncedViewsSearchQuery = useDebouncedValue(viewsSearchQuery, QUERY_OBJECT_DEBOUNCE_TIME_MS);
  return useFetchViewsByCategory(debouncedViewsSearchQuery);
};